"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyleButton = _interopRequireDefault(require("./StyleButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var INLINE_STYLES = [{
  label: 'B',
  style: 'BOLD'
}, {
  label: 'I',
  style: 'ITALIC'
}, {
  label: 'U',
  style: 'UNDERLINE'
}];
var InlineStyleControls = function InlineStyleControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "RichEditor-controls"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    role: "group"
  }, INLINE_STYLES.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement(_StyleButton["default"], {
      key: type.style,
      active: currentStyle.has(type.style),
      label: type.label,
      onToggle: props.onToggle,
      style: type.style
    });
  })));
};
InlineStyleControls.propTypes = {
  editorState: _propTypes["default"].object.isRequired,
  onToggle: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = InlineStyleControls;